$(document).ready(function(){

	//Price range slider
	if($('.slider').length > 0)
	{
		
		min = parseInt($('.slider-wrapper .min').attr('data-value'));
		max = parseInt($('.slider-wrapper .max').attr('data-value'));
	
		$('.slider').noUiSlider({		
									start: [min, max],
									
									step: 1,
									
									range: {
										'min': [ min ],
										'max': [ max ]
									}
									
								 }).Link('upper').to('-inline-<div class="tooltip"></div>', function(value){
		
									$('.max').html(
										'&pound;' + parseInt(value) + ''
									);
								}).Link('lower').to('-inline-<div class="tooltip"></div>', function(value){
		
									$('.min').html(
										'&pound;' + parseInt(value) + ''
									);
								}).on('set', resetFilters);
	}
	
	//
	$('.filter.clear a').on('click', function(e){
		
		e.preventDefault();
		
		$('.products > li').show();
		$('.group input[type=radio]').prop('checked', false);

		if($('.slider').length > 0)
		{
				
			max = $('.slider-wrapper .max').attr('data-value');
			min = $('.slider-wrapper .min').attr('data-value');

			$('.slider').val([min, max]);
		}
		
		$('.filter.clear').hide();
		
		if($(window).width() <= 990)
		{
			$('aside').hide();
			$('.small-refine a').removeClass('active');
		}
				
	});	
	
	//Standard filter
	$('.filter input').on('change', function(){
		resetFilters();
	});
	
	//Stock filter
	$('.stock input').on('change', function(){		
		resetFilters();
	});
		
	
	//Brand filter
	$('.brand input').on('change', function(){		
		resetFilters();
	});
	
	//Size filter
	$('.size input').on('change', function(){		
		resetFilters();
	});			
	
	function resetFilters()
	{				
		//Loop through all products on page
		$('.products > li').hide().each(function(){
									
			visible = true;						
				
			//Check standard filters
			options = $(this).attr('data-options');
			options = options.split(",");
										
			$('.filter input:checked').each(function(){
				
				option = $(this).val();
				
				if(option)
				{		
					if($.inArray(option, options) < 0)
					{
						visible = false;
					}
				}							
							
			});
			
			//Check stock filters
			stock = $('.stock input:checked').val();
			
			if(stock)
			{
				if(stock == 1)
				{
					if($(this).attr('data-stock-total') == 0)
					{
						visible = false;
					}	
				}
				else if(stock == 0)
				{
					if($(this).attr('data-stock-total') > 0)
					{
						visible = false;
					}						
				}
				
			}
			
			//Check brand filters
			brand_id = $('.brand input:checked').val();
			
			if(brand_id)
			{				
				if(brand_id != $(this).attr('data-brand_id'))
				{
					visible = false; 
				}			
			}
			
			//Check size filters
			sizes = $(this).attr('data-sizes');
			sizes = sizes.split(",");
										
			$('.size input:checked').each(function(){
				
				size = $(this).val();
				
				if(size)
				{		
					if($.inArray(size, sizes) < 0)
					{
						visible = false;
					}
				}							
							
			});		
							
			//Check price filters
			range = $('.slider').val();
			range = range.toString();								
			range = range.split(',');
			min = range[0];
			max = range[1];
			
			price = $(this).attr('data-filter_price');
			price = parseFloat(price);
			
			if( price < min || price > max )
			{
				visible = false;
			}
			
			//Only re-show it if still visible
			if(visible)
			{
				$(this).show();
			}
			
		});
		
		$('.filter.clear').show();
		
		if($(window).width() <= 990)
		{
			$('aside').hide();
		}				

	}
	
	//
	$('select[name=product_sort]').on('change', function(){
		
		category_url = $('.products').attr('data-category_url');
		category_id = $('.products').attr('data-category_id');
				
		post_data = { order: $(this).val(),
					  category_url: category_url };
					  		
		url = "../php/ajax/product.php?action=get-product-grid"
		
		$.post(url, post_data, function(data){
		
			$('.products').html(data);
			
			hide_clear = false;
			
			if(!$('.filter.clear').is(':visible'))
			{
				hide_clear = true;
			}	
			
			resetFilters();	
			
			if(hide_clear)
			{
				$('.filter.clear').hide();
			}
			
			if($(window).width() <= 990)
			{
				$('.small-sort').hide();
				$('.small-refine a').removeClass('active');
			}					
		});
		
	});
});
	
